<script>
  import { getContext, createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import debounce from "lodash/debounce";
  export let type = "text";
  export let name;
  export let value = "";
  export let formDetection = true;
  export let placeholder = "";



  const { onFormChange, form } = getContext("form");
  const dispatch = createEventDispatcher();
  const debounceTimeMs = 500;

  const onDebounce = debounce((event) => {
    handleDataChange(event);
  }, debounceTimeMs);

  function handleDataChange(event) {
    if (formDetection) onFormChange(event);
    dispatch("change", event);
  }

</script>

<div class="mt-1 sm:col-span-2 w-full">
  <textarea
    {value}
    {type}
    {name}
    {placeholder}
    on:blur={handleDataChange}
    on:input={onDebounce}
    class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-field-border-gray rounded-md h-24"
  />
</div>
